import { useLocation } from 'react-router-dom'

import { useFeatureFlags } from '@/contexts/FeatureFlagsContext'
import { isNavActive } from '@/lib/navigation'

import { SectionLink, SectionNav } from './SectionNav'

/** The point of sale group's pages the staff member may open (flags and permissions as in the main nav). */
function usePosLinks(): SectionLink[] {
  const { getSidebarItems } = useFeatureFlags()
  const { pathname } = useLocation()
  const pages = (getSidebarItems().find((item) => item.id === 'pos')?.children ?? []).filter((p) => p.to)
  const current = pages
    .flatMap((p) => (isNavActive(pathname, p.to!) ? [p.to!] : []))
    .sort((a, b) => b.length - a.length)[0]
  return pages.map((p) => ({ to: p.to!, label: p.label ?? '', icon: p.icon, nested: false, active: current === p.to }))
}

interface PosNavProps {
  /** Where "‹ Point of sale" goes: the last page visited outside point of sale. */
  exitTo: string
  onNavigate?: () => void
}

/** The point of sale column beside the icon rail on `/pos/*` routes, as settings has. */
export const PosNav = ({ exitTo, onNavigate }: PosNavProps) => (
  <SectionNav title="Point of sale" exitTo={exitTo} links={usePosLinks()} onNavigate={onNavigate} />
)
